export interface ProfilePoint {
  distance_km: number;
  elevation_m: number;
}

export interface SliceStats {
  distanceKm: number;
  gainM: number;
  lossM: number;
  timeMin: number | null;
  elevationM: number;
}

// Время участка по функции Тоблера (как на бэкенде, geometry.py::estimate_hiking_time_hours):
// W = 6 * exp(-3.5 * |S + 0.05|) км/ч, уклон клэмпится в ±2.
function toblerHours(lengthKm: number, riseM: number): number {
  if (lengthKm <= 0) return 0;
  const slope = Math.max(-2, Math.min(riseM / (lengthKm * 1000), 2));
  return lengthKm / (6 * Math.exp(-3.5 * Math.abs(slope + 0.05)));
}

// Статистика участка «от старта до курсора» по профилю высот: дистанция, набор,
// спуск, высота под курсором и время. Время масштабируется так, чтобы на конце
// профиля совпасть с общим временем маршрута (totalMinutes), а не с нашей
// упрощённой оценкой; без totalMinutes - null. Курсор клэмпится в границы профиля.
export function sliceStats(points: ProfilePoint[], cursorKm: number, totalMinutes: number | null): SliceStats | null {
  if (points.length < 2) return null;
  const end = points[points.length - 1].distance_km;
  const cursor = Math.max(0, Math.min(cursorKm, end));
  let gainM = 0;
  let lossM = 0;
  let sliceHours = 0;
  let totalHours = 0;
  let elevationM = points[0].elevation_m;
  for (let i = 1; i < points.length; i++) {
    const a = points[i - 1];
    const b = points[i];
    const len = b.distance_km - a.distance_km;
    totalHours += toblerHours(len, b.elevation_m - a.elevation_m);
    if (a.distance_km >= cursor) continue;
    const frac = len > 0 ? Math.min(1, (cursor - a.distance_km) / len) : 1;
    const rise = (b.elevation_m - a.elevation_m) * frac;
    if (rise > 0) gainM += rise;
    else lossM -= rise;
    sliceHours += toblerHours(len * frac, rise);
    elevationM = a.elevation_m + (b.elevation_m - a.elevation_m) * frac;
    if (frac < 1) {
      // дальше курсора - только добавляем длину участков к totalHours
      for (let j = i + 1; j < points.length; j++) {
        totalHours += toblerHours(points[j].distance_km - points[j - 1].distance_km, points[j].elevation_m - points[j - 1].elevation_m);
      }
      break;
    }
  }
  const timeMin = totalMinutes != null && totalHours > 0 ? (sliceHours / totalHours) * totalMinutes : null;
  return { distanceKm: cursor, gainM, lossM, timeMin, elevationM };
}
